import React from 'react';
import { PropTypes } from 'prop-types';
import Modal from 'components/ui/Modal';
import Spinner from 'admin-components/components/Spinner';

function BookingEmailSent({ isOpen, onClose }) {
  return <Modal isOpen={isOpen} onClose={onClose} title={<Spinner height={2} />} />;
}

BookingEmailSent.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default BookingEmailSent;
